import { forwardRef, useCallback, useState } from "react";
import { FormControl } from "react-bootstrap";
import { DatePickerInputStyled } from "./styled/DatePickerStyled";
import DatePickerLib, { registerLocale } from 'react-datepicker';
import { BinIcon } from "../Icon/Icon";
import gb from 'date-fns/locale/en-GB';
import 'react-datepicker/dist/react-datepicker.css';

registerLocale('gb', gb)

const DatePickerInput = forwardRef((props, ref) => {
    return (
        <DatePickerInputStyled>
            <FormControl ref={ref} className="pe-4" type="text" {...props}/>
            <BinIcon name={'IcDocCopy'} onClick={props.onClick}/>
        </DatePickerInputStyled>
    );
});

function DatePicker({ ...datePickerProps }) {

    const onSelectHandler = useCallback((date) => {
        if (datePickerProps?.onChange) {
            datePickerProps.onChange(date);
        }
    }, [datePickerProps]);

    return <DatePickerLib
        locale="gb"
        customInput={<DatePickerInput/>}
        onSelect={onSelectHandler}
        {...datePickerProps}
    />
}

export default DatePicker;
